module.exports = __webpack_public_path__ + "img/CHRISTOPHER- ENGINEERING.4ce9e2cb.jpg";